import { render, staticRenderFns } from "./HeadPortrait.vue?vue&type=template&id=15f0f826&scoped=true"
import script from "./HeadPortrait.vue?vue&type=script&lang=js"
export * from "./HeadPortrait.vue?vue&type=script&lang=js"
import style0 from "./HeadPortrait.vue?vue&type=style&index=0&id=15f0f826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0f826",
  null
  
)

export default component.exports